import { prop } from '@ipfabric/utils/fp/prop';
import { makeWrapWithButtonAsA } from 'components/Button/ButtonAsA';
import { showSidePanel } from 'components/Graph/commands/showSidePanel';
import { toggleLoadViewDialog } from 'components/Graph/commands/toggleLoadViewDialog';
import type { GraphCommandContext } from 'components/Graph/model/GraphCommandContext';
import type { GraphHook } from 'components/Graph/useGraph';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';
import type { CommandDispatcher } from 'utils/react/useCommandDispatcher';

/**
 * Graph empty page variants contain a similar set of links, so we can create them at one place
 * and not declare them for each empty page separately.
 */
const getCommonEmptyGraphTemplateLinks = (
  dispatch: CommandDispatcher<GraphCommandContext>,
) => ({
  linkPathChecks: makeWrapWithButtonAsA(() => {
    dispatch(showSidePanel, { intentVerificationTabId: 'path-checks' });
  }),
  linkNetworkViewer: makeWrapWithButtonAsA(() => {
    dispatch(showSidePanel, { networkViewerTabId: 'dataInput' });
  }),
  linkPathLookup: makeWrapWithButtonAsA(() => {
    dispatch(showSidePanel, { pathLookupTabId: 'dataInput' });
  }),
  linkSavedDiagramViews: makeWrapWithButtonAsA(() => {
    dispatch(toggleLoadViewDialog, { open: true });
  }),
});

export const selectCommonEmptyGraphTemplateLinks = createScopedSelector<
  GraphHook,
  ReturnType<typeof getCommonEmptyGraphTemplateLinks>
>(() => createSelector(prop('dispatch'), getCommonEmptyGraphTemplateLinks));
